import _ from 'lodash';
import _u from './util';
import _v from './vars';
import _t from './templates/templates_t';
import _feed from './templates/feed_t';
import { BUCKETID } from './constants/bucketIds_c';

let checkedUrls = [];
let globalCallouts = [];
let specialtyCallouts = [];
let callOutsDone = false;
let rcBarTimerClear = null;

Date.prototype.stdTimezoneOffset = function () {
    var jan = new Date(this.getFullYear(), 0, 1);
    var jul = new Date(this.getFullYear(), 6, 1);
    return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
}

Date.prototype.isDstObserved = function () {
    return this.getTimezoneOffset() < this.stdTimezoneOffset();
}

Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

function checkNumberofAlertsAndReports(specialtyData, commonData) {
    let finalResults = [];
	
	checkedUrls = [];
	
    specialtyData.forEach(element => {
		if (finalResults.length >= 2) {
			return;
		}
		if (checkedUrls.indexOf(element.url) == -1) {
			checkedUrls.push(element.url);
			finalResults.push(element);			
		}
    });
	
	if (finalResults.length < 2) {
        commonData.forEach(element => {
            if (finalResults.length >= 2) {
                return;
            }
			if (checkedUrls.indexOf(element.url) == -1) {
				checkedUrls.push(element.url);
				finalResults.push(element);			
			}
        });
    }
	
    return finalResults;
}

function bindCallouts(data) {	
    data.filter(data => data.type === 'alert').forEach(element => {
		element.url = element.url.replace(/((https?:)?\/\/)([^\.]+)(.+)?\.(medscape\.)([^\/]+)/, '$1$3.' + _u.getDomain() + '$5$6');
        if(_v.isFYE != null){
			element.url = element.url + '?src=FYE';
		}
		document.querySelector('.callouts-container').appendChild(_u.strToDom(_feed.alertFeeds(element)));
    });

    data.filter(callout => callout.type === 'report').forEach(element => {
        element.thumb = element.thumb.replace('medscapestatic.com', _u.getDomain() + 'medscapestatic.com');
        element.thumb = element.thumb.toString() + '?interpolation=lanczos-none&resize=120:*';
		element.url = element.url.replace(/((https?:)?\/\/)([^\.]+)(.+)?\.(medscape\.)([^\/]+)/, '$1$3.' + _u.getDomain() + '$5$6');
        document.querySelector('.callouts-container').appendChild(_u.strToDom(_feed.reportFeeds(element)));
    });
	document.dispatchEvent(new CustomEvent('calloutFullyLoaded'));
}

function commonCheckMethod(element) {
    if (typeof element.specialties != 'undefined' && element.specialties != null && element.specialties != '') {
        if (!element.specialties.split(',').includes(userHpName)) {
            return;
        }
    }

    let startDate = '';
    let endDate = '';
    let currentDate = new Date();

    if (typeof element.start != 'undefined' && element.start != null && element.start != '') {
        new Date(element.start).isDstObserved() ? element.start = element.start + ' EDT' : element.start = element.start + ' EST';
        startDate = element.start;
    }

    if (typeof element.end != 'undefined' && element.end != null && element.end != '') {
        new Date(element.end).isDstObserved() ? element.end = element.end + ' EDT' : element.end = element.end + ' EST';
        endDate = element.end;
    }

    if (startDate != "" && endDate != "") {
        if (currentDate >= new Date(startDate) && currentDate <= new Date(endDate)) {
            return element;
        }
    } else if (startDate != "" && endDate == "") {
        if (currentDate >= new Date(startDate)) {
            return element;
        }
    } else if (startDate == "" && endDate != "") {
        if (currentDate <= new Date(endDate)) {
            return element;
        }
    } else if (startDate == "" && endDate == "") {
        return element;
    }
}

function checkIfCalloutsValid(callouts) {
    let finalResult = [];
	checkedUrls = [];
	
    callouts.filter(data => data.type === 'alert').forEach(element => {
        if (finalResult.length === 2) {
            return;
        }

        let a = commonCheckMethod(element);
        if (a && typeof a.url != 'undefined' && checkedUrls.indexOf(a.url) == -1) {
			checkedUrls.push(a.url);
            finalResult.push(a);
        }
    });

    callouts.filter(callout => callout.type === 'report').forEach(element => {
        if (finalResult.length === 2) {
            return;
        }

        let r = commonCheckMethod(element);
        if (r && typeof r.url != 'undefined' && checkedUrls.indexOf(r.url) == -1) {
			checkedUrls.push(r.url);
            finalResult.push(r);
        }
    });

    return finalResult;
}

function getGlobalCallouts() {
	globalCallouts = [];
	_u.apiGet('https://img.' + _u.getDomain() + 'medscapestatic.com/medscape-files/for-you/callouts.json').then(gdata => {		
		if (gdata !== undefined && gdata != null) {
			if (gdata.callouts !== undefined && gdata.callouts != null && gdata.callouts.length > 0) { // Check newer JSON structure
				globalCallouts = checkIfCalloutsValid(gdata.callouts);
			} else if (typeof gdata.length != 'undefined' && gdata.length > 0) { // Backwards compatibility for original callout JSON
				globalCallouts = checkIfCalloutsValid(gdata);
			}
		}
		if (specialtyCallouts.length === 0 && globalCallouts.length > 0) {
			bindCallouts(globalCallouts); // If no specialty callouts and at least one global callout, display it
		} else if (specialtyCallouts.length > 0 && globalCallouts.length > 0) {
			bindCallouts(checkNumberofAlertsAndReports(specialtyCallouts, globalCallouts)); // If there are both kinds of callouts, sort them
		} else if (specialtyCallouts.length > 0) {
			bindCallouts(specialtyCallouts); // If there is only one valid specialty callout and no globals, display it
		} else {
			document.dispatchEvent(new CustomEvent('calloutFullyLoaded'));
		}
        document.dispatchEvent(new CustomEvent('calloutLoaded'));
	}).catch(error => {
		if (specialtyCallouts.length > 0) {
			bindCallouts(specialtyCallouts); // If global call fails, display any valid specialty callotus
            document.dispatchEvent(new CustomEvent('calloutLoaded'));
		}
		console.log(error);
	});
}

function chkRCLinkWidth() {
	let viewAllWidth = document.querySelector('.viewall-rc-button').offsetWidth;
	let rcBarWidth = document.querySelector('#rc-bar').offsetWidth;
	let availableRcWidth = rcBarWidth - viewAllWidth;	
	document.querySelectorAll('.rc-button:not(.viewall-rc-button)').forEach(function(elem) {
		if (!elem.classList.contains('active') && !elem.classList.contains('hidden')) {
			elem.classList.add('hidden'); // Ensures we can read offsetLeft / offsetWidth of element
		}
		if (elem.offsetLeft + elem.offsetWidth + 5 < availableRcWidth) {
			elem.classList.add('active');
			elem.classList.remove('hidden');
		} else {
			elem.classList.remove('active');
			elem.classList.remove('hidden');
		}
	});
	document.querySelector('.viewall-rc-button').classList.add('active');
}

function fillRCBar(e) {
	if (typeof e == 'undefined') { // run instantly first time
		chkRCLinkWidth();
	} else { // run after short-delay for resize event, to prevent too much triggering
		clearTimeout(rcBarTimerClear);
		rcBarTimerClear = setTimeout(chkRCLinkWidth, 100);
	}
}

function getRC(data) {
	let rcBar = _u.qS('#rc-bar');
	if (data.rc !== undefined && data.rc != null && data.rc.length > 0) {
		data.rc.forEach(element => {
			let extraClass = '';
			if (typeof element.coe != 'undefined' && element.coe) {
				extraClass = 'coe';
			}
			element.extraClass = extraClass;
			element.url = element.url.replace(/((https?:)?\/\/)([^\.]+)(.+)?\.(medscape\.)([^\/]+)/, '$1$3.' + _u.getDomain() + '$5$6');
			try {				
				rcBar.appendChild(_u.strToDom(_t.rcLink(element)));
			} catch(e) {
				console.log(e);
			}
		});
		if (rcBar.querySelectorAll('.rc-button').length > 0 && userHpName != 'multispecialty') {
			let specialtyName = userHpName;
			if (specialtyName == "businessofmedicine") {
				specialtyName = "businessmedicine";
			}
			let viewAll = {
				"title": "View All",
				"url": "/" + specialtyName + "/resource",		
				"extraClass": "viewall-rc-button"
			}
			rcBar.appendChild(_u.strToDom(_t.rcLink(viewAll)));
		}
		if (rcBar.querySelectorAll('.rc-button').length > 0) {
			rcBar.classList.add('active');
			if (rcBar.clientWidth < rcBar.scrollWidth) {
				rcBar.classList.add('overflowing');
			}
		}
		fillRCBar();
		document.addEventListener(_v.initialLoadEvent, fillRCBar);
		window.addEventListener('load', fillRCBar);
		window.addEventListener('resize', fillRCBar);
	}
}

function getCallouts() {
	specialtyCallouts = [];
	if (typeof userHpName != 'undefined' && userHpName != '') {
		_u.apiGet('https://img.' + _u.getDomain() + 'medscapestatic.com/medscape-files/for-you/' + userHpName + '/callouts.json').then(data => {
			if (data !== undefined && data != null) {
				getRC(data); // Share API data with RCs
				if (data.callouts !== undefined && data.callouts != null && data.callouts.length > 0) { // Check with RC JSON structure
					specialtyCallouts = checkIfCalloutsValid(data.callouts);
				} else if (typeof data.length != 'undefined' && data.length > 0) { // Backwards compatibility for original callout JSON
					specialtyCallouts = checkIfCalloutsValid(data);
				}
				if (specialtyCallouts.length >= 2) {
					bindCallouts(specialtyCallouts);
                    document.dispatchEvent(new CustomEvent('calloutLoaded'));				 
				}
				else {						
					getGlobalCallouts();
				}
			}
			else {
				getGlobalCallouts();
			}
		}).catch(error => {
			getGlobalCallouts(); // If Specialty JSON file not available, proceed with Global JSON
			console.log(error);
		});
	} else {
		getGlobalCallouts();
	}
}

function getConferenceCallouts() {
    if (typeof userHpId != 'undefined' && userHpId != '' && !isNaN(Number(userHpId))) {
		let bucketId = (_u.getDomain().indexOf('dev') != -1 || _u.getDomain().indexOf('qa') != -1) ? BUCKETID['qa'][userHpId] : BUCKETID['prod'][userHpId];

        if (typeof bucketId != 'undefined' && bucketId != null) {
            _u.apiGet('https://api.' + _u.getDomain(true) + 'medscape.com/contentqueryservice/bucketRendering/getTemplate?bucketID=' + bucketId +'&renderingTypeId=1&sort=postingDate:desc').then(data => {

                let callouts = data.renderingData.pages;
                // First check which callouts are valid from the list
                let filteredCallouts = checkWhichCalloutsAreValid(callouts);
				
				function appendConfCallout() {
	                if (filteredCallouts.length > 0) {
						filteredCallouts.forEach((callout, index) => {
							// add only firat callout form the list
							if (index === 0) {
								// If alert tag not present
								if (_u.qS('.alert-tag') == null) {
									document.querySelector('.callouts-container').insertBefore(_u.strToDom(_feed.conferenceCalloutFeeds(callout)), document.querySelector('.callouts-container').firstChild);
								} else {
									// If alert tag is present
									document.querySelectorAll('.alert-tag').forEach(function(element){
										let ele = _u.getClosest(element, '.pers-feed-item');
										_u.insertAfter(_u.strToDom(_feed.conferenceCalloutFeeds(callout)), ele);
									});
								}
							}
						});
					}
					document.dispatchEvent(new CustomEvent('confCalloutLoaded'));
				}
				if (callOutsDone) {
					appendConfCallout();
				} else {					
					document.addEventListener('calloutLoaded', appendConfCallout);
				}
            }).catch(error => {
				document.dispatchEvent(new CustomEvent('confCalloutLoaded'));
                console.log(error);
            });
        } else {
			document.addEventListener('calloutLoaded', function(){
				document.dispatchEvent(new CustomEvent('confCalloutLoaded'));
			});
		}
    } else {
		document.addEventListener('calloutLoaded', function(){
			document.dispatchEvent(new CustomEvent('confCalloutLoaded'));
		});
	}
}

function checkWhichCalloutsAreValid(params) {
    let result = [];

    if (params.length > 0) {
        params.forEach(element => {
            let date = element.conferenceByline != undefined ? element.conferenceByline.split(';')[0] : null;
            if (checkIfConferenceCalloutisValid(date)) {
                result.push(element);
            }
        });
    }

    return result;
}

function checkIfConferenceCalloutisValid(date) {
    if (date != null) {
        let a = date.split(';')[0];
        let isDifferetYear = a.split('-')[0].includes(',');
        let offset = -5.0;
        let currentDate = new Date();
        let utcCurrent = currentDate.getTime() + (currentDate.getTimezoneOffset() * 60000);
        currentDate = new Date(utcCurrent + (3600000*offset));

        // this is different year condition example "December 23, 2021-January 14, 2022"
        if (isDifferetYear) {
            let endDate = a.split('-')[1];
            endDate = new Date(endDate.split(',')[0].split(' ')[1] + ' ' + endDate.split(',')[0].split(' ')[0] + ' ' + endDate.split(',')[1]);

            let utc = endDate.getTime() + (endDate.getTimezoneOffset() * 60000);
            let estEndDate = new Date(utc + (3600000*offset)).addDays(7);

            //Check if the date is valid
            return currentDate <= estEndDate ? true : false;
        } else {
            // this is non different year condition
            let year = date.split(',')[1].toString().trim();
            let isdifferentMonths = date.split(',')[0].split('-')[1].length <= 2 ? false: true;

            // this is same month or different month condition
            if (!isdifferentMonths) {
                let month = date.split(',')[0].split(' ')[0].toString().trim();

                let toDate = new Date(date.split(',')[0].split(' ')[1].split('-')[1].toString().trim() + ' ' + month + ' ' + year);
                // Make it into EST format

                let utc = toDate.getTime() + (toDate.getTimezoneOffset() * 60000);
                let estEndDate = new Date(utc + (3600000*offset)).addDays(7);

                //Check if the date is valid
                return currentDate <= estEndDate ? true : false;
            } else {
                // Create EndDate
                let toDate = new Date(date.split(',')[0].split('-')[1].split(' ')[1] + ' ' + date.split(',')[0].split('-')[1].split(' ')[0] + ' ' + year);

                // Make it into EST format
                let utcT = toDate.getTime() + (toDate.getTimezoneOffset() * 60000);
                toDate = new Date(utcT + (3600000*offset)).addDays(7);

                return currentDate <= toDate ? true : false;
            }
        }
    }
}

document.addEventListener('calloutLoaded', function() {
	callOutsDone =  true;	
});
getConferenceCallouts();


export default getCallouts;